import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * Unmatched user modal - component
 */
@Component({
	selector: 'app-nonmatched-user-modal',
	templateUrl: './nonmatched-user-modal.component.html',
	styleUrls: ['./nonmatched-user-modal.component.scss'],
})
export class NonMatchedUserModalComponent {
	/**
	 * Flag to check if buttons has to be displayed on modal
	 */
	showButtons = false;
	/**
	 * Modal title
	 */
	title: any = 'Account verification takes up to 24 hours.';

	/**
	 * Unmatched modal constructor
	 * @param dialogRef - dialog reference
	 */
	constructor(private dialogRef: MatDialogRef<NonMatchedUserModalComponent>) {}

	/**
	 * Gets action type and passes the same on closing modal
	 * @param actionType - action value
	 */
	getAction(actionType: string): void {
		if (actionType === 'CLOSE') {
			this.dialogRef.close();
		}
	}

	/**
	 * On closing modal
	 */
	dismiss() {
		this.dialogRef.close();
	}
}
